// Presentational field building blocks for the consultation form.
export function TextField({ label, labelCls, inputCls, testId, ...rest }) {
    return (
        <div>
            <label className={labelCls}>{label}</label>
            <input data-testid={testId} className={inputCls} {...rest} />
        </div>
    );
}

export function SelectField({ label, labelCls, inputCls, testId, options, ...rest }) {
    return (
        <div>
            <label className={labelCls}>{label}</label>
            <select data-testid={testId} className={inputCls} {...rest}>
                <option value="">Select…</option>
                {options.map((o) => (
                    <option key={o} value={o}>
                        {o}
                    </option>
                ))}
            </select>
        </div>
    );
}

export function TextareaField({ label, labelCls, inputCls, testId, ...rest }) {
    return (
        <div>
            <label className={labelCls}>{label}</label>
            <textarea data-testid={testId} className={inputCls} {...rest} />
        </div>
    );
}
